import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import Solutions from './pages/Solutions';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminPosts from './pages/admin/AdminPosts';
import PostEditor from './pages/admin/PostEditor';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './i18n/LanguageContext';
import { AuthProvider, RequireAuth } from './admin/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  
  return null;
};

// Visitor tracking component
const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    // Track page visits via backend API
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track-visitor`, {
          page: location.pathname,
          user_agent: navigator.userAgent
        });
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Visitor tracking failed:', error.message);
      }
    };

    trackVisit();
  }, [location]);

  return null;
};

const PublicSite = () => (
  <>
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products/:slug" element={<ProductDetail />} />
      <Route path="/solutions" element={<Solutions />} />
      <Route path="/about" element={<About />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
    <Footer />
    <FloatingWhatsAppButton />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <ScrollToTop />
              <VisitorTracker />
              <Routes>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                  <Route index element={<AdminPosts />} />
                  <Route path="posts/:id" element={<PostEditor />} />
                </Route>
                <Route path="/*" element={<PublicSite />} />
              </Routes>
              <Toaster position="top-right" richColors />
            </BrowserRouter>
          </div>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
